export const style = {
  wrapper: {
    margin: `0 -15px`
  },
  wrapperActive: {
    // marginTop: `85px`
  },
  box: {
    // border: `1px solid #ccc`,
    borderTop: `none`,
    borderBottom: `none`
  },
  row: {
    border: `1px solid transparent`,
    padding: `20px`,
    borderBottom: `1px solid #f4f4f4`,
    cursor: `pointer`,
    ':hover': {
      border: `1px solid #ececec`,
      background: `#fbfbfb`,
      borderRadius: `3px`
    }
  },
  header: {
    height: `100%`,
    borderBottom: `1px solid #ececec`,
    paddingBottom: `15px`
  },
  headerColumn: {
    padding: `0 5px`,
    ':first-of-type': {
      padding: 0
    }
  },
  button: {
    display: `block`,
    height: `30px`,
    lineHeight: `30px`,
    padding: `0 20px`,
    fontSize: `12px`,
    border: `1px solid #ececec`,
    background: `#fbfbfb`,
    cursor: `pointer`
  },
  searchInput: {
    height: `30px`,
    fontSize: `12px`,
    padding: `8px 20px`,
    width: `100%`,
    border: `1px solid #ececec`
  },
  searchButton: {},
  title: {
    fontWeight: 600,
    fontSize: `15px`,
    // color: `#A94545`,
    overflow: `hidden`,
    display: `inline-block`,
    textOverflow: `ellipsis`,
    whiteSpace: `nowrap`,
    width: `100%`
  },
  counter: {
    // fontWeight: `600`,
    color: `#A94545`
  },
  message: {
    fontWeight: 300,
    fontSize: `13px`,
    overflow: `hidden`,
    display: `inline-block`,
    textOverflow: `ellipsis`,
    whiteSpace: `nowrap`,
    width: `100%`
  },
  author: {
    fontSize: `13px`,
    '@media (min-width: 992px)': {
      fontSize: `15px`
    }
    // lineHeight: `44px`
  },
  statusWrapper: {
    height: `44px`
  },
  datetime: {
    '@media (min-width: 992px)': {
      display: `block`,
      textAlign: `center`
    },
    color: `#777`
  },
  time: {
    fontWeight: 600,
    fontSize: `13px`
  },
  date: {
    fontSize: `14px`,
    color: `#777`
  },
  category: {
    fontWeight: 600,
    fontSize: `13px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Support/style/table.js